<div class="column is-flex py-0">
  @for (reason of rejectionReasonsGeneral; track reason.value) {
    @if (!reason.hiddenWhenDocumentType?.includes(documentType())) {
      <button
        class="mr-2 mt-2"
        fino-button
        [attr.data-testid]="reason.value + '_rejection'"
        (click)="setRejectionReason(reason.value)"
        [icon]="reason.icon"
        [primary]="reason.higlightedBy.includes(rejectionReason)"
      >
        <span [class.ml-2]="!isClarification()">{{ reason.translation | translate }}</span>
      </button>
    }
  }

  <button class="mt-2" type="button" (click)="openDeleteModal()" fino-button>
    @if (!isClarification()) {
      <fino-icon icon="Bin 1"></fino-icon>
    }
    <span [class.ml-2]="!isClarification()" translate="identifyDocument.deleteModal.title"></span>
  </button>
</div>

@if (!hideRejectionReasons) {
  <div class="is-flex">
    <div class="pl-3 is-flex is-flex-wrap-wrap">
      <button
        class="mr-2 mt-2"
        [attr.data-tooltip]="'identifyDocument.rejectionReason.tooltip' | translate"
        fino-button
        icon="Envelope"
        [disabled]="isMailInfoDisabled()"
        (click)="rejectionReasonTemplate('mailInfo')"
        aria-label="Mail Information"
      ></button>
      @for (reason of rejectionReasonsDetailed; track reason) {
        <button
          class="mr-2 mt-2"
          [disabled]="!hasRejectionReasonOther"
          fino-button
          [attr.data-testid]="reason + '_detailed_rejection'"
          [primary]="rejectionReason === reason && hasRejectionReasonOther"
          (click)="rejectionReasonTemplate(reason)"
        >
          {{ reason | translate }}
        </button>
      }
    </div>
  </div>

  @if (rejectionReasonVisible()) {
    <form class="mt-4 px-2" [formGroup]="form()">
      <fino-textarea
        formControlName="rejectionReasonText"
        label="rejectionReasonText"
        [readonly]="true"
      >
      </fino-textarea>
    </form>
  }
}
